function Namespace() {}
Namespace.prototype = Object.create(null);

export default Namespace;
